import Client from "../Client";

describe("Client model", () => {
  test("hasMany relations", () => {
    expect(Client.hasMany.map(relation => relation.name)).toMatchSnapshot();
  });
});
